import React, { ComponentProps } from 'react';
import Type from 'components/Type';

const LeadParagraph = (props: ComponentProps<typeof Type.P>) => (
  <Type.P variant="celloCanon" {...props} />
);

export default LeadParagraph;
